var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10198",
    "data-name": "Group 10198",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 12,
    height: 12,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2816",
    "data-name": "Group 2816",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10612",
    "data-name": "Path 10612",
    d: "M11.067,9.626V2.374a1.2,1.2,0,1,0-.533,0v3.36H7.867V2.374a1.2,1.2,0,1,0-.533,0v3.36H4.667V2.374a1.2,1.2,0,1,0-.533,0v3.36H1.467V2.374a1.2,1.2,0,1,0-.533,0V6a.268.268,0,0,0,.267.267H4.133v3.36a1.2,1.2,0,1,0,.533,0V6.267H7.333v3.36a1.2,1.2,0,1,0,.533,0V6.267h2.667v3.36a1.2,1.2,0,1,0,.533,0M.533,1.2A.66.66,0,0,1,1.2.533a.66.66,0,0,1,.667.667.66.66,0,0,1-.667.667A.66.66,0,0,1,.533,1.2m4.533,9.6a.667.667,0,1,1-.667-.667.66.66,0,0,1,.667.667M4.4,1.867A.66.66,0,0,1,3.733,1.2a.667.667,0,0,1,1.333,0,.66.66,0,0,1-.667.667M8.267,10.8a.667.667,0,1,1-.667-.667.66.66,0,0,1,.667.667M7.6,1.867A.66.66,0,0,1,6.933,1.2a.667.667,0,0,1,1.333,0,.66.66,0,0,1-.667.667M10.133,1.2a.667.667,0,0,1,1.333,0,.667.667,0,0,1-1.333,0M10.8,11.467a.667.667,0,1,1,.667-.667.66.66,0,0,1-.667.667",
    fill: "#152c40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon8);
export default __webpack_public_path__ + "static/media/social-icon8.198f0607359bd1851f841c6cd6ddb069.svg";
export { ForwardRef as ReactComponent };